export const formatQuantityValue = (quantityValue) => {
  if (quantityValue == null || Number.isNaN(Number(quantityValue))) {
    return '';
  }

  const totalMinutes = Math.round(Number(quantityValue));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const parts = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }

  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }

  return parts.join(' ') || '0m';
};
